module.exports = __webpack_public_path__ + "static/img/materialsInfo2.4568b0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo2.png
// module id = FW4s
// module chunks = 2